import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { BgColorOptions, ColorOptions } from '@df/ui/atomic/atomic-options';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../cms/block/abstract-cms-block.component';

export interface ILoginFormContentBlock extends NICmsContentComponent.IData {
    items?: ILoginFormItem[];
    font_color?: string;
    background_color?: string;
}

export interface ILoginFormItem {
    image: string;
    title: string;
}

@Component({
    selector: 'login-form-content-block',
    templateUrl: './login-form-content-block.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<LoginFormContentBlockComponent>({
    id: 'login-form-content-block',
    block: {
        url: 'login-form-content-block'
    },
    onDemandOnly: true,
    name: 'Login Form Content Block',
    description: 'Content block used in login form',
    fields: [
        <NICmsContentField.IRepeaterField>{
            key: 'items',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Items',
            itemName: 'Item',
            itemNameField: 'item',
            fields: [
                <NICmsContentField.IField>{
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'image',
                    type: NICmsContentField.EFieldType.image,
                    title: 'Image',
                    required: true
                }
            ],
            default: []
        },
        <NICmsContentField.IChoiceField>{
            key: 'font_color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Font colour',
            colorPreview: true,
            options: ColorOptions
        },
        <NICmsContentField.IChoiceField>{
            key: 'background_color',
            type: NICmsContentField.EFieldType.choice,
            title: 'Background colour',
            colorPreview: true,
            options: BgColorOptions
        }
    ]
})
export class LoginFormContentBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: ILoginFormContentBlock;

    protected _isEmpty(): boolean {
        return !this.content?.items?.length;
    }
}
